(function () {
  'use strict';

  var _swat;
  var _cache = [];

  function isWishlisted(empi, epi) {
    return _cache.some(function (item) {
      return item.empi === empi && item.epi === epi;
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('.product-block__wishlist-btn').forEach(function (btn) {
      var empi = Number(btn.dataset.empi);
      var epi  = Number(btn.dataset.epi);
      var wishlisted = isWishlisted(empi, epi);
      btn.classList.toggle('swym-added', wishlisted);
      btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
      btn.hidden = false;
    });
  }

  // rs-wishlist.js fetches the wishlist and broadcasts state here
  document.addEventListener('on:wishlist:state', function (e) {
    _cache = (e.detail && e.detail.items) || [];
    updateAllButtons();
  });

  // Event delegation — handles dynamically loaded cards too
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-block__wishlist-btn');
    if (!btn || !_swat) return;
    e.preventDefault();

    var product = {
      epi:  Number(btn.dataset.epi),
      empi: Number(btn.dataset.empi),
      du:   btn.dataset.du,
      dt:   btn.dataset.dt,
      iu:   btn.dataset.iu,
      pr:   Number(btn.dataset.pr)
    };

    if (btn.classList.contains('swym-added')) {
      _swat.removeFromWishList(product, function () {
        document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
      });
    } else {
      _swat.addToWishList(product, function () {
        document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
      });
    }
  });

  // Store swat for click handling; initial state arrives via on:wishlist:state
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    _swat = swat;
  });
})();
